export default "__VITE_ASSET__BJexx1fV__"